/* @flow */

import moment from 'moment';
import DebtorCompany from 'models/companies/debtorCompany';

import InsertInvoiceRequest from 'models/requests/sellers/insertInvoiceRequest';
import UpdateInvoiceRequest from 'models/requests/sellers/updateInvoiceRequest';

export default class SellInvoiceForm {
  debtorCompany: DebtorCompany;
  reference: string;
  debtAmount: number;
  dueDate: moment;
  issueDate: moment;

  constructor() {
    this.debtorCompany = null;
    this.reference = '';
    this.debtAmount = '';
    this.dueDate = null;
    this.issueDate = null;
  }

  toInsertRequest(sellerCompanyId: number) {
    const request = new InsertInvoiceRequest();
    request.sellerCompanyId = sellerCompanyId;
    request.debtorCompanyId = this.debtorCompany.id;
    request.reference = this.reference;
    request.debtAmount = this.debtAmount;
    request.dueDate = moment(this.dueDate).format('YYYY/MM/DD');
    request.issueDate = moment(this.issueDate).format('YYYY/MM/DD');
    return request;
  }

  toUpdateRequest(sellerCompanyId: number, invoiceId: number) {
    const request = new UpdateInvoiceRequest();
    request.sellerCompanyId = sellerCompanyId;
    request.invoiceId = invoiceId;
    request.reference = this.reference;
    request.debtAmount = this.debtAmount;
    request.dueDate = moment(this.dueDate).format('YYYY/MM/DD');
    request.issueDate = moment(this.issueDate).format('YYYY/MM/DD');
    return request;
  }
}
